<template>
  <div>
    <h4 class="mb-4 text-center text-uppercase">Aggiungi nuovo articolo</h4>
    {{ item}}
    <ValidationObserver ref="form" v-slot="{ reset }">
      <b-form ref="form" @submit.prevent="onSubmit" @reset.prevent="reset" v-if="!submitted">
        <b-form-input id="id" type="text" style="display: none" v-if="isEdit" v-model.lazy="form.id"></b-form-input>
        <autocomplete id="articolo_autocomplete" :required="true" anchor="id" :options="items" url="https://ordini.saegsrl.com/ajax/search.php" label="name" :onShouldGetData="updateItems" :min="minLen" placeholder="Codice Articolo" :onSelect="selectItem">
        </autocomplete>
        <b-form-group id="articolo">
          <ValidationProvider rules="required" name="Codice articolo" v-slot="{ errors }" slim>
            <input id="articolo" type="hidden" v-model="form.articolo">
            <pulse-loader :loading="spinner.loading" size="10px" :color="spinner.color" ></pulse-loader>
            <div class="mt-1 alert alert-danger alert-sm" role="alert" v-if="errors[0] && clickedSubmit">
              {{ errors[0] }}
            </div>
          </ValidationProvider>
        </b-form-group>
        <b-form-group id="descrizione">
          <b-form-textarea
              id="descrizione"
              v-model.lazy="form.descrizione"
              placeholder="Descrizione"
          ></b-form-textarea>
        </b-form-group>
        <b-form-group id="quantita">
          <ValidationProvider name="Quantita" vid="quantita"
                              :rules="{ numeric: true, checkMag: { otherValue: '@mag' } }"
                              v-slot="{ errors }">
            <b-form-input
                id="quantita"
                v-model.lazy="form.quantita"
                type="number"
                placeholder="Quantità"
            ></b-form-input>
            <div class="mt-1 alert alert-danger alert-sm" role="alert" v-if="errors[0]">
              {{ errors[0] }}
            </div>
          </ValidationProvider>
        </b-form-group>
        <b-form-group id="mag">
          <ValidationProvider name="MAG" vid="mag"
                              :rules="{ numeric: true, checkQnt: { otherValue: '@quantita' } }"
                              v-slot="{ errors }">
            <b-form-input
                id="mag"
                v-model.lazy="form.mag"
                type="number"
                placeholder="Mag"
            ></b-form-input>
            <div class="mt-1 alert alert-danger alert-sm" role="alert" v-if="errors[0]">
              {{ errors[0] }}
            </div>
          </ValidationProvider>
        </b-form-group>
        <b-form-group id="cliente">
          <ValidationProvider name="Cliente" rules="required" v-slot="{ errors }">
            <b-form-input
                id="cliente"
                v-model.lazy="form.cliente"
                type="text"
                placeholder="Cliente"
            ></b-form-input>
            <div class="mt-1 alert alert-danger alert-sm" role="alert" v-if="errors[0]">
              {{ errors[0] }}
            </div>
          </ValidationProvider>
        </b-form-group>
        <b-form-group id="note">
          <b-form-textarea
              id="note"
              v-model.lazy="form.note"
              placeholder="Note"
          ></b-form-textarea>
        </b-form-group>
        <b-form-group id="priorita">
          <b-form-checkbox-group v-model.lazy="form.priorita" id="priorita">
            <b-form-checkbox value="1">URGENTE</b-form-checkbox>
          </b-form-checkbox-group>
        </b-form-group>

        <b-button type="submit" class="btn-lg btn-full-width" variant="secondary" v-if="!isEdit">
          <b-icon-cart3></b-icon-cart3>
          Aggiungi al carrello
        </b-button>
        <b-button type="submit" class="btn-lg btn-full-width" variant="secondary" v-if="isEdit">
          <b-icon-cart3></b-icon-cart3>
          Modifica articolo
        </b-button>
      </b-form>
      <hr/>
      <b-button type="button" v-on:click="onCheckout()" class="btn-lg btn-full-width" variant="primary"
                v-if="hasProduct() > 0">
        <b-icon-card-checklist></b-icon-card-checklist>
        Val al Carrello <small v-if="getProductsInCart.length == 1">( {{ getProductsInCart.length }} articolo
        )</small><small
          v-if="getProductsInCart.length > 1">( {{ getProductsInCart.length }} articoli )</small></b-button>

      <br/>
      <br/>
      <p>
        <router-link to="/login">Logout</router-link>
      </p>
    </ValidationObserver>
  </div>
</template>

<script>
import ItemTemplate from './ItemTemplate.vue'
import {mapState, mapActions, mapGetters} from 'vuex'
import {extend} from "vee-validate";
import {router} from "../_helpers";
import Autocomplete from 'vue2-autocomplete-js';

extend("checkMag", {
  params: ["otherValue"],
  validate: (value, {otherValue}) => {
    if (
        otherValue > 0
    ) {
      return false;
    }
    return true;
  },
  message:
      "I campi quantita e mag non possono essere compilati entrambi."
});

extend("checkQnt", {
  params: ["otherValue"],
  validate: (value, {otherValue}) => {
    if (
        otherValue > 0
    ) {
      return false;
    }
    return true;
  },
  message:
      "I campi quantita e mag non possono essere compilati entrambi."
});

export default {
  components: { Autocomplete },
  computed: {
    ...mapState({
      account: state => state.account,
      cart: state => state.account
    }),
    ...mapGetters('cart', [
      'getProductsInCart',
    ])
  },
  data() {
    return {
      minLen: 1,
      newItem: null,
      notExistsSuggestion: false,
      spinner: {
        loading: false,
        color: '#000000'
      },
      autoSelectOneItem: false,
      item: '',
      items: [],
      template: ItemTemplate,
      clickedSubmit: false,
      form: {
        id: '',
        articolo: '',
        descrizione: '',
        cliente: '',
        note: '',
        quantita: '',
        mag: '',
        priorita: []
      },
      isEdit: false,
      show: true,
      submitted: false
    }
  },
  mounted() {

    if (localStorage.getItem('cart')) {
      try {
        this.cart = JSON.parse(localStorage.getItem('cart'));
      } catch (e) {
        localStorage.removeItem('cart');
      }
    }

    if (localStorage.getItem('edit') > 0) {
      this.editItemCart(localStorage.getItem('edit'));
    }
  },
  methods: {
    ...mapActions('cart', ['addProduct', 'removeProduct']),

    getLabel (item) {
      return ( item ? item.name : null );
    },
    selectItem(item){
      console.log(item);
      this.form.articolo = "";
      if(item.id)
      {
        this.form.articolo = item.id;
        this.form.descrizione = item.description;
      }
    },
    updateItems (text) {
      let _this = this;
      this.spinner.loading = true;
      fetch(`https://ordini.saegsrl.com/ajax/search.php?t=` + text).then(this.handleResponse).then(response => {
        this.items = response;
        _this.notExistsSuggestion = false;
        if(this.items.length == 0) _this.notExistsSuggestion = true;
        this.spinner.loading = false;
      })
    },
    handleResponse(response) {
      return response.text().then(text => {
        const data = text && JSON.parse(text);
        if (!response.ok || data.error) {
          const error = (data && data.message) || response.statusText;
          return Promise.reject(error);
        }
        return data;
      });
    },
    onSubmit() {
      this.clickedSubmit = true;
      this.$refs.form.validate().then(success => {
        if (!success) {
          return;
        }
        if (this.isEdit) {
          var self = this;
          var i = 0;
          this.getProductsInCart.map(function (item) {
            if (item.id == self.form.id) {
              self.removeProduct(i);
            }
            i++;
          });
        }
        this.addItemCart(this.form);
        this.resetForm();
        this.$refs.form.reset();
        if (this.isEdit) {
          this.onCheckout();
          this.isEdit = false;
        }
      });
    },
    addItemCart(value) {
      value.id = new Date().getTime();
      this.addProduct(value);
    },
    editItemCart(id) {
      var me = this;
      this.getProductsInCart.map(function (item) {
        if (item.id == id) {
          me.isEdit = true;
          me.form = {
            articolo: item.articolo,
            descrizione: item.descrizione,
            cliente: item.cliente,
            note: item.note,
            id: id,
            quantita: item.quantita,
            mag: item.mag,
            priorita: item.priorita
          }
        }
      });
      localStorage.removeItem('edit');
    },
    hasProduct() {
      return this.getProductsInCart.length > 0;
    },
    onCheckout() {
      router.push('/checkout');
    },
    resetForm() {
      this.item = '';
      this.items= [];
      this.form = {
        articolo: '',
        descrizione: '',
        cliente: '',
        note: '',
        quantita: '',
        mag: '',
        priorita: []
      }
    }
  },

};
</script>